@use "variables" as *;

.itemCard {
  margin: $spacing-s $spacing-s $spacing-m $spacing-s;
}

.itemCardMobile {
  margin: $spacing-s 0 $spacing-m 0;
}
